import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "status-loading",
  templateUrl: "./status-loading.component.html",
  styleUrls: ["./status-loading.component.scss"],
  standalone: false,
})
export class StatusLoadingComponent implements OnInit {
  @Input() isLoading: boolean = true;
  @Input() loadingClass = "min-h-80";

  constructor() {}

  ngOnInit(): void {}
}
